/**
 * UI state store
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useUIStore = create()(persist((set, get) => ({
    theme: 'system',
    sidebarOpen: true,
    sidebarCollapsed: false,
    modals: {
        createMeeting: false,
        deleteMeeting: false,
        settings: false,
    },
    toasts: [],
    setTheme: (theme) => {
        set({ theme });
    },
    toggleSidebar: () => {
        set((state) => ({ sidebarOpen: !state.sidebarOpen }));
    },
    setSidebarOpen: (open) => {
        set({ sidebarOpen: open });
    },
    setSidebarCollapsed: (collapsed) => {
        set({ sidebarCollapsed: collapsed });
    },
    openModal: (modal) => {
        set((state) => ({
            modals: {
                ...state.modals,
                [modal]: true,
            },
        }));
    },
    closeModal: (modal) => {
        set((state) => ({
            modals: {
                ...state.modals,
                [modal]: false,
            },
        }));
    },
    closeAllModals: () => {
        set((state) => {
            const modals = { ...state.modals };
            Object.keys(modals).forEach((key) => {
                modals[key] = false;
            });
            return { modals };
        });
    },
    addToast: (message, type = 'info', duration = 5000) => {
        const id = `${Date.now()}-${Math.random()}`;
        const toast = {
            id,
            message,
            type,
            duration,
        };
        set((state) => ({
            toasts: [...state.toasts, toast],
        }));
        // Auto-remove after duration
        if (duration > 0) {
            setTimeout(() => {
                get().removeToast(id);
            }, duration);
        }
    },
    removeToast: (id) => {
        set((state) => ({
            toasts: state.toasts.filter((t) => t.id !== id),
        }));
    },
    clearToasts: () => {
        set({ toasts: [] });
    },
}), {
    name: 'voxapilot-ui',
    partialize: (state) => ({
        // Only persist theme and sidebar state
        theme: state.theme,
        sidebarCollapsed: state.sidebarCollapsed,
    }),
}));
//# sourceMappingURL=ui.js.map